/**
 * @generated SignedSource<<6e8f3226641ecd01dd1a2748d8070e2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionGuideSectionRelayFragment$data = {
  readonly collectionSteps: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly relatedTemplate: {
      readonly urlSlug: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"templateCardRelayFragment">;
    } | null | undefined;
    readonly stepDescription: string | null | undefined;
    readonly stepSubheading: string | null | undefined;
  }> | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "collectionGuideSectionRelayFragment";
};
export type collectionGuideSectionRelayFragment$key = {
  readonly " $data"?: collectionGuideSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionGuideSectionRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionGuideSectionRelayFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateCollectionStep",
      "kind": "LinkedField",
      "name": "collectionSteps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepSubheading",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplate",
          "kind": "LinkedField",
          "name": "relatedTemplate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlSlug",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "templateCardRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateCollectionGuide",
  "abstractKey": null
};
})();

(node as any).hash = "67408a1c6a9e105ceb80f53fded94380";

export default node;
